/**
 * What ONDO is, said plainly — and said identically on every surface.
 *
 * MOVED HERE from `apps/web-frontend/src/about/about.constants.ts` on 4 October,
 * when the phone needed the same words. It is the same reason `DECLARATIONS` moved:
 * this is text somebody relies on. A collector reads it to find out what the
 * registry claims about their work, and a phone and a website that described the
 * registry differently would be two registries.
 *
 * Every sentence is a claim the access rules enforce **today**. Something the
 * schema cannot yet answer goes in as a row marked not issued, never as a promise
 * phrased in the present tense. That rule is why this file is prose rather than
 * marketing: it is checked against the policies, and changing a policy means
 * changing a sentence here.
 */
export const ABOUT_SECTIONS = [
    {
        key: "registry",
        title: "A registry, not a database",
        body: "ONDO records who holds a work, who made it, and who says so. A collection is the unit of access and a work is the unit of record: everyone who can see a collection can see the works in it, and a grant on a single work says nothing about the collection holding it. That direction is deliberate — it is what lets you show one piece to a valuer without opening the rest of what you own.",
    },
    {
        key: "registering",
        title: "Registering",
        body: "Anyone may register a work. There is no queue and no approval: you catalogue a piece and it sits in your collection straight away, held by you. The registry does not decide whether to believe a record — what a work is worth believing rests entirely on its provenance, which is the next section.",
    },
    {
        key: "provenance",
        title: "Provenance, and who stands behind it",
        body: "A work carries a chain of title: one entry per holder, saying who had it, from when, and how they came by it. An entry is added or withdrawn and never edited, so the record only grows. Anyone who can see an entry may put their name to it — or against it — and each account holds one position per entry. ONDO counts those signatures and disputes and concludes nothing from them: a count of who will stand behind a claim is a fact, and a verdict would be ours to be wrong about.",
    },
    {
        key: "authorities",
        title: "Who authenticates",
        body: "Nobody, in the sense of a stamp. Studios, estates, foundations and catalogue raisonné archives are appointed by ONDO and nobody can nominate themselves — but what an appointment buys is the weight of a name on a provenance entry, not a power to approve or refuse a record. Signing up as an artist does not link you to works bearing your name; that link is a registry act.",
    },
    {
        key: "possession",
        title: "Possession and ownership",
        body: "Where a work is and who owns it are different facts. A loan records that an institution has your work; it does not change who holds it. Where the physical object is kept follows the collection, never a single-work grant, so a piece shown for a valuation does not also disclose the store it came from.",
    },
    {
        key: "sharing",
        title: "Sharing",
        body: "You share a collection with an ONDO id, at viewer or curator. A curator can help catalogue; only an owner can share further, rename, or move a work. Access is append-only: revoking someone ends the grant rather than deleting it, so re-inviting them later cannot quietly restore the level they used to hold.",
    },
];
//# sourceMappingURL=about.js.map